import cx from 'classnames'
import PropTypes from 'prop-types'

import FilterItemBasic, {filterItemBasicDesigns} from '@adv-mt/mt-filter-item-basic'

import {LIST_CLASS_NAME, LIST_ITEM_CLASS_NAME} from '../../config.js'
import useFilterBasic from '../hooks/useFilterBasic.js'

const FilterBasicDefault = ({
  allSelectionsId,
  allSelectionsImageSrc,
  allSelectionsLabel,
  checkElementType,
  hasIconCheck,
  isLeftIcon,
  isFullWidth,
  isMultiSelect,
  isNestedList,
  isScrollable,
  listDesign,
  listDirection,
  listItemDirection,
  listItemsDesign,
  onChange,
  options,
  value,
  withDivider
}) => {
  const {hasAllOptionsChecked, hasAllSelectionsField, onSelectAll, onSelectItem} = useFilterBasic({
    allSelectionsId,
    allSelectionsLabel,
    isMultiSelect,
    onChange,
    options,
    value
  })

  const listClassName = isNestedList ? `${LIST_CLASS_NAME}Nested` : LIST_CLASS_NAME

  const baseClasses = cx(
    listClassName,
    isScrollable && `${listClassName}--scrollable`,
    listDirection && `${listClassName}--${listDirection}`,
    listDesign && `${listClassName}--${listDesign}`,
    listItemsDesign === filterItemBasicDesigns.OUTLINED && `${listClassName}--spaced`,
    withDivider && `${listClassName}--withDivider`
  )

  const listItemClassName = isNestedList ? `${LIST_ITEM_CLASS_NAME}Nested` : LIST_ITEM_CLASS_NAME

  const listItemClassNames = cx(`${listItemClassName}`, listDesign && `${listItemClassName}--${listDesign}`)

  return (
    <ul className={baseClasses}>
      {hasAllSelectionsField && (
        <li className={listItemClassNames}>
          <FilterItemBasic
            checkElementType={checkElementType}
            design={listItemsDesign}
            direction={listItemDirection}
            hasIconCheck={hasIconCheck}
            imageSrc={allSelectionsImageSrc}
            isBolder
            isFullWidth={isFullWidth}
            isSelected={hasAllOptionsChecked}
            label={allSelectionsLabel}
            onChange={onSelectAll}
            tabIndex="0"
          />
        </li>
      )}
      {options.map(
        ({extendedInfo, icon, element, id, imageSrc, isDisabled, label, description, attributes, rightIcon}, index) => {
          return (
            <li className={listItemClassNames} key={id}>
              <FilterItemBasic
                attributes={attributes}
                checkElementType={checkElementType}
                description={description}
                design={listItemsDesign}
                direction={listItemDirection}
                element={element}
                extendedInfo={extendedInfo}
                hasIconCheck={hasIconCheck}
                icon={icon}
                id={id}
                imageSrc={imageSrc}
                isDisabled={isDisabled}
                isFullWidth={isFullWidth}
                isLeftIcon={isLeftIcon}
                isSelected={value.includes(id)}
                label={label}
                onChange={onSelectItem}
                paddingLess={!isNestedList && options.length === 1 && Boolean(checkElementType)}
                rightIcon={rightIcon}
                tabIndex={hasAllSelectionsField ? index + 1 : index}
              />
            </li>
          )
        }
      )}
    </ul>
  )
}

FilterBasicDefault.displayName = 'FilterBasicDefault'
FilterBasicDefault.propTypes = {
  allSelectionsId: PropTypes.string,
  allSelectionsImageSrc: PropTypes.string,
  allSelectionsLabel: PropTypes.string,
  checkElementType: PropTypes.string,
  hasIconCheck: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isLeftIcon: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  isNestedList: PropTypes.bool,
  isScrollable: PropTypes.bool,
  listDesign: PropTypes.string,
  listDirection: PropTypes.string,
  listItemDirection: PropTypes.string,
  listItemsDesign: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.func,
      id: PropTypes.string.isRequired,
      imageSrc: PropTypes.string,
      isDisabled: PropTypes.bool,
      label: PropTypes.string.isRequired,
      rightIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
    })
  ),
  value: PropTypes.arrayOf(PropTypes.string),
  withDivider: PropTypes.bool
}

export default FilterBasicDefault
